/* eslint-disable @typescript-eslint/ban-ts-comment */
import StreamSaver from 'streamsaver';
import * as ponyfill from 'web-streams-polyfill/ponyfill';

// @ts-expect-error
StreamSaver.WritableStream = ponyfill.WritableStream;
StreamSaver.mitm = `${window.location.origin}/wb/mitm.html`;
